import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import Box from "@material-ui/core/Box";
import { TableRow } from "@material-ui/core";

import { setBreadcrumb } from "../../actions/common";
import ScrollableTable from "../Common/Table/ScrollableTable";
import TableCellStyled from "../Common/TableCellStyled";
import { fetchGet } from "../../api/fetch";

const styles = {
  container: {
    margin: "24px",
    minHeight: "unset",
    height: "calc(100vh - 196px)",
    overflow: "auto",
    padding: "24px"
  },
  content: {
    marginTop: "24px",
    maxWidth: "815px"
  }
};

const renderTableData = data => {
  if (data === undefined) {
    return <TableRow><TableCellStyled colSpan={8} align="center">Loading...</TableCellStyled></TableRow>;
  }
  return Array.isArray(data)
    ? data.map(item => (
      <TableRow key={`${item.company.id}_${item.site.id}`}>
        <TableCellStyled>{item.company.name}</TableCellStyled>
        <TableCellStyled>{item.site.name}</TableCellStyled>
        <TableCellStyled>{item.sec_count}</TableCellStyled>
        <TableCellStyled>{item.a_machine_count}</TableCellStyled>
        <TableCellStyled>{item.vmi_count}</TableCellStyled>
        <TableCellStyled>{item.pzi_count}</TableCellStyled>
        <TableCellStyled>{item.user_count}</TableCellStyled>
      </TableRow>
    ))
    : <TableRow><TableCellStyled colSpan={8} align="center" style={{ color: 'red' }}>{data}</TableCellStyled></TableRow>;
};

const VMIConfigurationMetrics = props => {
  const { classes, dispatch } = props;

  const [data, setData] = React.useState();

  React.useEffect(() => {
    dispatch(
      setBreadcrumb([
        {
          name: "dashboards",
          display: false
        },
        {
          name: I18n.get("sidebar_vmiConfigurationMetrics")
        }
      ])
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    fetchGet('/vmi/configuration-metrics')
      .then(res => {
        setData(res);
      })
      .catch(e => {
        setData(`Can't load metrics: ${e.message}`);
        console.log(e);
      });
  }, []);

  let columns = [
    {
      name: "dashboard_vmiConfigurationMetrics_company",
      minWidth: 200,
      width: 200
    },
    {
      name: "dashboard_vmiConfigurationMetrics_site",
      minWidth: 200,
      width: 200
    },
    {
      name: "dashboard_vmiConfigurationMetrics_sector",
      minWidth: 70,
      width: 70,
    },
    {
      name: "dashboard_vmiConfigurationMetrics_vending_machine",
      minWidth: 70,
      width: 70
    },
    { name: "dashboard_vmiConfigurationMetrics_vmi", minWidth: 70, width: 70 },
    { name: "code_bin", minWidth: 70, width: 70 },
    { name: "dashboard_vmiConfigurationMetrics_users", minWidth: 70, width: 70 }
  ];

  return (
    <Box className={`mainContent ${classes.container}`}>
      <ScrollableTable columns={columns}>
        {renderTableData(data)}
      </ScrollableTable>
    </Box>
  );
};

const mapStateToProps = state => {
  return {
    language: state.user.language
  };
};

export default connect(mapStateToProps)(
  withStyles(styles)(VMIConfigurationMetrics)
);
